import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useInstructor } from '@/features/profile/hooks/useInstructor';

const LoadingScreen: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
    <div className="text-lg font-medium">Loading...</div>
  </div>
);

/**
 * Route guard that allows access only to authenticated instructors.
 * - Not logged in        → /
 * - Logged in, not instructor → /home
 * - Instructor           → renders children
 */
export const InstructorRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const { isInstructor, isLoading: roleLoading } = useInstructor();

  if (authLoading || roleLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!isInstructor) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
